module.exports = __webpack_public_path__ + "static/media/butterCheese.8c1d7e6c.webp";